module.exports = __webpack_public_path__ + "static/media/16.09020454.jpg";